const baseUrl = "https://aady-server.onrender.com/api"; //'https://aadyportfolioapi.cyclic.app/api'
// const baseUrl = "http://localhost:8000/api";

export default baseUrl;
